module.exports = __webpack_public_path__ + "static/img/calculator.56f4d93.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/calculator.png
// module id = 820
// module chunks = 0